import { render, staticRenderFns } from "./ResidentialAddressModal.vue?vue&type=template&id=655b64b9&scoped=true&"
import script from "./ResidentialAddressModal.vue?vue&type=script&lang=js&"
export * from "./ResidentialAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./ResidentialAddressModal.vue?vue&type=style&index=0&id=655b64b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b64b9",
  null
  
)

export default component.exports